/** 接入点列表 query key 与渠道页同一个,渠道页建完回来不用重拉。 */
export const KEFU_WEB_ENTRIES_QUERY_KEY = ["cs-web-entries"] as const;

/**
 * 纯判定(单测直接测):**只有**企微客服确认未绑 且 网页 / H5 接入点确认为 0 才提示。
 * 任一边查不到(undefined:无权限 / 加载中 / 接口失败)都不下结论 —— 宁可少提示,不误报。
 */
export function shouldShowNoChannel(
  wecomBound: boolean | undefined,
  webEntryCount: number | undefined
): boolean {
  return wecomBound === false && webEntryCount === 0;
}
